import script from "./TheTooltip.vue?vue&type=script&setup=true&lang=js"
export * from "./TheTooltip.vue?vue&type=script&setup=true&lang=js"

import "./TheTooltip.vue?vue&type=style&index=0&id=42888cc6&lang=scss"

const __exports__ = script;

export default __exports__